// extracted by mini-css-extract-plugin
export var modalBody = "Y_fk";
export var gridWallets = "Y_bZ";
export var textDisclaimer = "Y_fl";
export var rotate = "Y_c";
export var dotty = "Y_d";